import ApiGroupInstance from './ApiGroupInstance.container';

export default ApiGroupInstance;
